export enum ATTENDEE_TYPE {
  INTERVIEWEE = 'INTERVIEWEE',
  INTERVIEWEE_SECURE = 'INTERVIEWEE_SECURE',
  INTERVIEWER = 'INTERVIEWER',
}
